module.exports = React;


//////////////////
// WEBPACK FOOTER
// external "React"
// module id = 2
// module chunks = 0